module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"dueAt":"Data de vencimento"},"en-US":{"dueAt":"Due date"}}')
  delete Component.options._Ctor
}
